import React from 'react';
import { matchPath } from 'react-router-dom';
import { isMobileDevice } from 'utils/browserCheck';
import { routes } from 'constants/config';
import PartnerFeedbackReportMobile from 'components/ReportCard/RolePlay/PartnerFeedbackReportMobile';
import PartnerFeedbackReportDesktop from 'components/ReportCard/RolePlay/PartnerFeedbackReportDesktop';
import { useFetch } from 'hooks';

const isLibraryPath = pathname => !!matchPath(pathname, { path: '/library' });

const getRolePlayFeedbacksUrl = ({ pathname }, pathId, lessonId) => {
  const isLearningLibraryPath = isLibraryPath(pathname);

  if (isLearningLibraryPath) {
    return pathId
      ? routes.LEARNING.REPORT_CARD.LIBRARY_PATH_LESSON_ROLE_PLAY_FEEDBACKS(
          pathId,
          lessonId,
        )
      : routes.LEARNING.REPORT_CARD.LIBRARY_LESSON_ROLE_PLAY_FEEDBACKS(
          lessonId,
        );
  }

  return pathId
    ? routes.LEARNING.REPORT_CARD.PATH_LESSON_ROLE_PLAY_FEEDBACKS(
        pathId,
        lessonId,
      )
    : routes.LEARNING.REPORT_CARD.LESSON_ROLE_PLAY_FEEDBACKS(lessonId);
};

const PartnerFeedbackWrapper = ({ location, match: { params } }) => {
  const { lessonId, pathId } = params;
  const rolePlayFeedbacksUrl = getRolePlayFeedbacksUrl(
    location,
    pathId,
    lessonId,
  );
  const { loading, error, data = {} } = useFetch(rolePlayFeedbacksUrl);

  const PartnerFeedbackReport = () => {
    return isMobileDevice() ? (
      <PartnerFeedbackReportMobile feedbacks={data.feedbacks} />
    ) : (
      <PartnerFeedbackReportDesktop feedbacks={data.feedbacks} />
    );
  };

  return (
    <>
      {!loading && !error && data.feedbacks.length > 0 && (
        <>
          <h4 className="mt-30">{t('progress.report_card.role_play.title')}</h4>
          <PartnerFeedbackReport />
        </>
      )}
    </>
  );
};

export default PartnerFeedbackWrapper;
